import { render, staticRenderFns } from "./ResourceLoadingIndicator.vue?vue&type=template&id=4bc662ec&scoped=true&"
import script from "./ResourceLoadingIndicator.vue?vue&type=script&lang=js&"
export * from "./ResourceLoadingIndicator.vue?vue&type=script&lang=js&"
import style0 from "./ResourceLoadingIndicator.vue?vue&type=style&index=0&id=4bc662ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bc662ec",
  null
  
)

export default component.exports